document.addEventListener("DOMContentLoaded", function () {
    console.log("JavaScript cargado y script ejecutándose...");

    function validarNombre(input) {
        let mensaje = "Debe ingresar un nombre válido.";
        let regex = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g;
        validarCampo(input, regex, mensaje);
    }

    function validarTelefono(input) {
        let mensaje = "Debe ingresar un número válido.";
        let regex = /^[0-9-+() ]*$/g;
        if (input.value.trim() === "") return limpiarMensaje(input);
        validarCampo(input, regex, mensaje);
    }

    function validarEmail(input) {
        let mensaje = "Debe ingresar un email válido.";
        let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        validarCampo(input, regex, mensaje);
    }

    function validarComentario(input) {
        let mensaje = "Comentario inválido.";
        let regex = /^[a-zA-Z0-9ñÑäÄëËïÏöÖüÜáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ?$@#()'!,+\-=_:.&€£*%\s]+$/g;
        validarCampo(input, regex, mensaje);
    }

    function validarCampo(input, regex, mensaje) {
        let errorSpan = input.nextElementSibling;
        if (errorSpan && errorSpan.tagName === "SPAN") {
            errorSpan.remove();
        }
        if (!regex.test(input.value)) {
            let span = document.createElement("span");
            span.textContent = mensaje;
            input.parentNode.insertBefore(span, input.nextSibling);
            input.value = "";
        }
    }

    function limpiarMensaje(input) {
        let errorSpan = input.nextElementSibling;
        if (errorSpan && errorSpan.tagName === "SPAN") {
            errorSpan.remove();
        }
    }

    document.querySelector("#formenexum #F1")?.addEventListener("blur", function () {
        validarNombre(this);
    });

    document.querySelector("#formenexum #F3")?.addEventListener("blur", function () {
        validarTelefono(this);
    });

    document.querySelector("#formenexum [name='F2']")?.addEventListener("blur", function () {
        validarEmail(this);
    });

    document.querySelector("#formenexum [name='F5']")?.addEventListener("blur", function () {
        validarComentario(this);
    });

    let form = document.querySelector("#formenexum");
    if (form) {
        form.addEventListener("submit", function (event) {
            let button = document.querySelector("#buttonFormEnviar");
            if (button) {
                button.disabled = true;
                button.textContent = "Enviando…";
                setInterval(() => {
                    button.style.opacity = button.style.opacity === "0.3" ? "1" : "0.3";
                }, 500);
            }
        });
    }
});
